<template>
 <div class="tab-pane fade" id="Profit-LossReport" role="tabpanel"  aria-labelledby="home-tab">

                <div class="row col-sm-12">

                   <div class="col-sm-12">                  
                    <div class="form-group "><button @click="getreport()" class="btn btn-primary">Home</button></div>                  
                  </div>
                  
                  <div class="col-sm-5">
                    <div class="input-group input-daterange"><datepicker value="" format="MM/dd/yyyy" id="startprof" :bootstrap-styling="true" class="datewidth"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker  value="" format="MM/dd/yyyy" id="endprof" :bootstrap-styling="true" class="datewidth"></datepicker></div>
                  </div>
                  <div class="col-sm-1">
                     <button class="btn btn-primary btn-sm" @click="getreport()">Search</button>
                  </div>

                  <div class="col-sm-6">Quick Inquiry
                    <b-button-group size="sm">
                    <b-button @click="setdate(1)">Previous day</b-button>
                    <b-button @click="setdate(2)">Today</b-button>
                    <b-button @click="setdate(3)">Last Week</b-button>
                    <b-button @click="setdate(4)">This Week</b-button>
                    <b-button @click="setdate(5)">Last Month</b-button>
                    <b-button @click="setdate(6)">This Month</b-button>
                    </b-button-group>
                  </div>

                </div>
                <div class="row" style="overflow-x: auto; white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputprofitagent"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterprofitagent"
              type="search"
              id="filterInputprofitagent"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="indukdatas"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterprofitagent"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                        <template v-slot:cell(total_bet_amount)="data" align="center">
                         {{formatCurrency(data.value)}}
                        </template>
                         <template v-slot:cell(win_lost)="data" align="center">
                           <font v-if="data.value > 0" color="#ff4747"> {{ formatCurrency(data.value) }} </font>
                            <font v-if="data.value <= 0" color="blue"> {{ formatCurrency(data.value) }} </font>
                        </template>
                        <template v-slot:cell(valid_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                         <template v-slot:cell(rebate)="data" align="center">
                            {{formatPrice(data.value)}}
                        </template>
                        <template v-slot:cell(myrebate)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(mypl)="data" align="center">
                 
                         <font v-if="data.value > 0" color="#ff4747"> {{ formatCurrency(data.value) }} </font>
                            <font v-if="data.value <= 0" color="blue"> {{ formatCurrency(data.value) }} </font>
                        </template>

                        <template v-slot:cell(commit_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(commit_win_lost)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(actual_settlement)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(shareholder_win)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="indukdatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
    </div>

                <div style="padding-top:30px;">
                  <div class="b-b b-theme nav-active-theme mb-3">
                     <ul class="nav nav-pills" id="myTabchild">
                        <li class="nav-item">
                        <a 
                        class="nav-link active" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#childreportsa"
                        role="tab" 
                        aria-controls="home" 
                        aria-selected="true">
                        Direct Inferior Agent P/L Report
                      </a>
                    </li>

                     <li class="nav-item">
                        <a 
                        class="nav-link" 
                        id="reportsa"
                        data-toggle="tab" 
                        href="#clientsa"
                        role="tab" 
                        aria-controls="home" 
                        >
                        Direct Inferior Client P/L Report
                      </a>
                    </li>
                     </ul>
                   </div>
                   <div class="tab-content mb-4">
                  <div class="tab-pane fade active show" id="childreportsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                     <h3 id="type_exp">{{ activeket }}</h3>
                    
                    <div class="" >

    <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterchild"
              type="search"
              id="filterInputChild"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty
                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="mydatas"
                      :fields="fieldchilds"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterchild"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                        <template v-slot:cell(option)="row" align="center">
                         <button class="btn btn-primary" @click="getreport(row.item.user_id)">Details</button>
                        </template>
                        <template v-slot:cell(total_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                         <template v-slot:cell(win_lost)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                        <template v-slot:cell(valid_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                         <template v-slot:cell(rebate)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                        <template v-slot:cell(rebate_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(net_pl)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(commit_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(commit_win_lost)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(actual_settlement)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(shareholder_win)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                    
                    </b-table>


      <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="mydatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                    
                  </div>
                  </div>
                </div>
                      </div>

                  <div class="tab-pane fade" id="clientsa" role="tabpanel" aria-labelledby="home-tab">
                  <div class="row" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">
                    <h3>Client </h3>

    <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputClient"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filterclient"
              type="search"
              id="filterInputClient"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true               
                      show-empty
                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="clientdatas"
                      :fields="fieldclients"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filterclient"
                      :filterIncludedFields="filterClientOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                        <template v-slot:cell(option)="row" align="center">
                         <button class="btn btn-primary" @click="getpluser(row.item.user_id,row.item.username)">Details</button>
                        </template>
                        <template v-slot:cell(total_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                         <template v-slot:cell(win_lost)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                        <template v-slot:cell(valid_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                         <template v-slot:cell(rebate)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                        <template v-slot:cell(rebate_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(net_pl)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(commit_bet_amount)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                        <template v-slot:cell(commit_win_lost)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(actual_settlement)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>

                         <template v-slot:cell(shareholder_win)="data" align="center">
                         {{formatPrice(data.value)}}
                        </template>
                    
                    </b-table>


    <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="clientdatas.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                    

                  </div>
                </div>
                      </div>
                   </div>
                </div>
                </div>

</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'


export default {
  name: "profitlossreport",
  data: function() {
    return {
        mydatas : [],
        clientdatas :[],
        dataTable:null,
        dataTableAnak:null,
        indukdatas : [],
        activeuser : "",
        activetype : "",
        activeket : "Agent",
        fields: [
          { key : 'agent_type', label : 'Class'},
          { key: 'username', label: 'Username', sortable: true,  },
          { key: 'game', label: 'Game'},
          { key: 'total_bet_amount', label: 'Total Bet Amount'},
          { key: 'win_lost', label: 'Player Win/Lost'},
          { key: 'valid_bet_amount', label: 'Valid Bet Amount'},
          { key: 'type', label: 'Type'},
          { key: 'rebate', label: 'Rebate'},
          { key: 'myrebate', label: 'Rebate Amount'},
          { key: 'mypl', label: 'Net P/L'},
          { key: 'share', label: 'Share %'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Total Bet Amount'},
          { key: 'commit_win_lost', label: 'Commit Shareholder Win/Lost'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Valid Bet Amount'},
          { key: 'actual_settlement', label: 'Actual Settlement'},
          { key: 'shareholder_win', label: 'Shareholder Win %'},
        ],
         fieldchilds: [
          { key : 'option', label : 'Option'},
          { key : 'agent_type', label : 'Class'},
          { key: 'username', label: 'Username', sortable: true,  },
          { key: 'currency_name', label: 'Currency'},
          { key: 'game', label: 'Game'},
          { key: 'total_bet_amount', label: 'Total Bet Amount'},
          { key: 'win_lost', label: 'Player Win/Lost'},
          { key: 'valid_bet_amount', label: 'Valid Bet Amount'},
          { key: 'type', label: 'Type'},
          { key: 'rebate', label: 'Rebate'},
          { key: 'rebate_amount', label: 'Rebate Amount'},
          { key: 'net_pl', label: 'Net P/L'},
          { key: 'share', label: 'Share %'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Total Bet Amount'},
          { key: 'commit_win_lost', label: 'Commit Shareholder Win/Lost'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Valid Bet Amount'},
          { key: 'actual_settlement', label: 'Actual Settlement'},
          { key: 'shareholder_win', label: 'Shareholder Win %'},
        ],
        fieldclients: [
          { key : 'option', label : 'Option'},
          { key : 'agent_type', label : 'Class'},
          { key: 'username', label: 'Username', sortable: true,  },
          { key: 'game', label: 'Game'},
          { key: 'total_bet_amount', label: 'Total Bet Amount'},
          { key: 'win_lost', label: 'Win/Lost'},
          { key: 'valid_bet_amount', label: 'Valid Bet Amount'},
          { key: 'type', label: 'Type'},
          { key: 'rebate', label: 'Rebate'},
          { key: 'rebate_amount', label: 'Rebate Amount'},
          { key: 'net_pl', label: 'Net P/L'},
          { key: 'share', label: 'Share %'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Total Bet Amount'},
          { key: 'commit_win_lost', label: 'Commit Shareholder Win/Lost'},
          { key: 'commit_bet_amount', label: 'Commit Shareholder Valid Bet Amount'},
          { key: 'actual_settlement', label: 'Actual Settlement'},
          { key: 'shareholder_win', label: 'Shareholder Win %'},
        ],
        currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filterprofitagent: null,
      filterOn: [],
      filterchild : null,
      filterChildOn : [],
      filterclient : null,
      filterClientOn : [],
    }
  },
  components: {
    Datepicker
  },
  computed: {
   ...mapGetters(["allProfitLossReports","singleUser","allTabs"]),
   getAllProfitLossReports(){
      return this.allProfitLossReports
   },
    getUser(){
      return this.singleUser
   },
    getTabs() {
      return this.allTabs
    },
  total: function(){
    var tot_bet_amount = 0;
    var tot_win_lost = 0;
    var tot_valid_bet = 0;
    var tot_rebate = 0;
    var tot_net_pl = 0;
    var tot_commit_bet = 0;
    var tot_commit_winlost = 0;
    var tot_actual_setlement = 0;
    var tot_share_win = 0;

    return this.mydatas.reduce(function(total, item){

      //debugger;

      tot_bet_amount = tot_bet_amount + parseFloat(item.total_bet_amount);
      tot_win_lost = tot_win_lost + parseFloat(item.win_lost);
      tot_valid_bet = tot_valid_bet + parseFloat(item.valid_bet_amount);
      tot_rebate = tot_rebate + parseFloat(item.rebate_amount);
      tot_net_pl = tot_net_pl + parseFloat(item.net_pl);
      tot_commit_bet = tot_commit_bet + parseFloat(item.commit_bet_amount);
      tot_commit_winlost = tot_commit_winlost + parseFloat(item.commit_win_lost);
      tot_actual_setlement = tot_actual_setlement + parseFloat(item.actual_settlement);
      tot_share_win = tot_share_win + parseFloat(item.shareholder_win);

      total = {
        tot_bet_amount : tot_bet_amount,
        tot_win_lost : tot_win_lost,
        tot_valid_bet : tot_valid_bet,
        tot_rebate : tot_rebate,
        tot_net_pl : tot_net_pl,
        tot_commit_bet : tot_commit_bet,
        tot_commit_winlost : tot_commit_winlost,
        tot_actual_setlement : tot_actual_setlement,
        tot_share_win : tot_share_win
      }
      return total;
     // return total + item.total_bet_amount; 
    },0);
  },
  totalclients: function(){
    var tot_bet_amount = 0;
    var tot_win_lost = 0;
    var tot_valid_bet = 0;
    var tot_rebate = 0;
    var tot_net_pl = 0;
    var tot_commit_bet = 0;
    var tot_commit_winlost = 0;
    var tot_actual_setlement = 0;
    var tot_share_win = 0;

    return this.clientdatas.reduce(function(total, item){

      //debugger;

      tot_bet_amount = tot_bet_amount + parseFloat(item.total_bet_amount);
      tot_win_lost = tot_win_lost + parseFloat(item.win_lost);
      tot_valid_bet = tot_valid_bet + parseFloat(item.valid_bet_amount);
      tot_rebate = tot_rebate + parseFloat(item.rebate_amount);
      tot_net_pl = tot_net_pl + parseFloat(item.net_pl);
      tot_commit_bet = tot_commit_bet + parseFloat(item.commit_bet_amount);
      tot_commit_winlost = tot_commit_winlost + parseFloat(item.commit_win_lost);
      tot_actual_setlement = tot_actual_setlement + parseFloat(item.actual_settlement);
      tot_share_win = tot_share_win + parseFloat(item.shareholder_win);

      total = {
        tot_bet_amount : tot_bet_amount,
        tot_win_lost : tot_win_lost,
        tot_valid_bet : tot_valid_bet,
        tot_rebate : tot_rebate,
        tot_net_pl : tot_net_pl,
        tot_commit_bet : tot_commit_bet,
        tot_commit_winlost : tot_commit_winlost,
        tot_actual_setlement : tot_actual_setlement,
        tot_share_win : tot_share_win
      }
      return total;
     // return total + item.total_bet_amount; 
    },0);
  }
  },
  methods : {
    getreport(usid='',type=''){

      let defuser = this.getUser
      let theid = ''
      if (usid == '' || usid == '0'){
        theid = defuser.user_id;
       // document.getElementById('type_exp').innerHtml("Agent");
        
      } else {
        theid = usid;
        //document.getElementById('type_exp').innerHtml("Client");
      }

       let par = {
           id : theid
        }

      this.activeuser = theid;

      var awal = ''+$('#startprof').val()+' 00:00:00';
       var akhir = ''+$('#endprof').val()+' 23:59:59';

     // debugger;
      
      var ep = '';
      var ket = '';
      if (type == 0){
        ep = 'agent';
        ket = 'AGENT';
      } else if (type == 1){
        ep = 'client';
        ket = 'CLIENT';
      }

      this.activetype = type;
      this.activeket = ket;

      ep = 'agent';
      ket = 'Agent';

      var myurl = '';

       $("#mb-load").modal();

      if (awal != '' && akhir != ''){
        myurl = ep+'/profitloss?user_id='+theid+'&startdate='+awal+'&enddate='+akhir;
      } else {
        myurl = ep+'/profitloss?user_id='+theid;
      }

       //debugger;

        api.get(myurl).then(({ data }) => {

          //debugger;
          
          this.indukdatas = [];
          this.mydatas = [];


          var myarr = data.data;


           
         /* var cek = {

          }*/
          var am_wl = 0;
          if (myarr.win_lost !== 'undefined'){
            am_wl = myarr.win_lost;
          }
          myarr.myrebate = Math.round((myarr.rebate/100) * myarr.valid_bet_amount);

          myarr.mypl = am_wl + (Math.round((myarr.rebate/100) * myarr.valid_bet_amount));

         // debugger;

          
          
          this.indukdatas.push(myarr);

        

          var mychilds = myarr.children;

          var filter2 = new Object();

          if (awal != ''){
              Object.assign(filter2, {start_date: awal});
          }

          var childs = mychilds;

        //  this.mydatas = mychilds;

        /*  var childs = mychilds.filter(function(item) {
          for (var key in filter2) {
            var itemTime = new Date(item['start_date']);
            var newawal = new Date(awal);
            var newakhir =  new Date(akhir);
          //  debugger;
            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
        });*/



         // debugger;
           for (var i = childs.length - 1; i >= 0; i--) {  
                this.mydatas.push(childs[i]);
            }
         //   debugger;
               $("#mb-load").modal('hide');
         })

      var myurl2 = '';

      if (awal != '' && akhir != ''){
        myurl2 = 'client/profitloss?user_id='+theid+'&startdate='+awal+'&enddate='+akhir;
      } else {
        myurl2 = 'client/profitloss?user_id='+theid;
      }


         api.get(myurl2).then(({ data }) => {
          
          console.log("Thedata")
          console.log(data.data)

          var myarr = data.data;



          
          this.clientdatas = [];
          
          
          var mychilds = myarr.children;

          var filter2 = new Object();

          if (awal != ''){
              Object.assign(filter2, {start_date: awal});
          }

          var childs = mychilds;

         /* var childs = mychilds.filter(function(item) {
          for (var key in filter2) {
            var itemTime = new Date(item['start_date']);
            var newawal = new Date(awal);
            var newakhir =  new Date(akhir);
            if (itemTime < newawal || itemTime > newakhir) 
              return false;
            }
          return true;
        });*/

          
           for (var i = childs.length - 1; i >= 0; i--) {  
                this.clientdatas.push(childs[i]);
            }
           // debugger;
          
         })

       /* this.$store.dispatch(TYPES.FETCH_PROFITLOSSREPORT, par).then(() => {
           console.log("dua")
          /*  var myarr = this.getAllProfitLossReports;
          
          this.indukdatas.push(myarr);
          var childs = myarr.children;
          if (childs){
           for (var i = childs.length - 1; i >= 0; i--) {  
                this.mydatas.push(childs[i]);
            }
          }
          debugger;
        });*/

       // this.$store.dispatch(TYPES.FETCH_PROFITLOSSREPORT, par).then(() => {

       // });

       
      //  console.log('cektes1')

        /*var myarr = this.getAllProfitLossReports;
        //console.log('cektes')
        //console.log(myarr)
        //debugger;
        //this.indukdatas.push(myarr); 
        this.indukdatas.push(myarr);
        var childs = myarr.children;
        if (childs){
         for (var i = childs.length - 1; i >= 0; i--) {
              
             
              this.mydatas.push(childs[i]);
          }
        }
        debugger;*/
    },
    formatPrice(value) {
       /* let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")*/
         let val = (value/1).toFixed(2).replace(',', '.')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
   mynewcolor(value) {
     var myval = value.toString();
     if (value > 0){
        return myval.fontcolor("red");
     } else {
        return myval.fontcolor("white");
     }
  },
     formatCurrency(value) {
          let val = (value/1).toFixed(2).replace(',', '.')
          return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    rowClass(indukdatas) {
        debugger;
        if (indukdatas.win_loss > 0){
           return '#ff4747'
        } else {
           return '#FFFFFF'
        }
    },
     onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering

        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    getreportclient(usid='',usname=''){
       
     /*  var addtab = '<li class="nav-item" id="'+usid+'"><a  class="nav-link active" id="btn-pl-'+usname+'" data-toggle="tab" href="#tab'+usid+'" role="tab" aria-controls="home" aria-selected="true">'+usname+'</a> <x-icon size="1.5x" class="close-tab" @click="removebut(tab'+usid+')"></x-icon></li>';
       $('#myTab').append(addtab);
       var addcontent = '<div role="tabpanel" aria-labelledby="home-tab" class="tab-pane fade" id="tab'+usid+'"><div class="card border-alpha-15" ><div class="card-header p-2"><h5>Client P/L Report</h5></div><div class="card-body p-2"><div class="container"></div></div></div></div>';
       $('#myTabContent').append(addcontent);*/
       let tab = {
        id: "pl"+usid,
        name: "PL-"+usname,
        usid : usid,
        type : "2"
      }

      let isExists = _.find(this.getTabs, {name: tab.name})
      if(!isExists) {
        this.$store.dispatch(TYPES.CREATE_TAB, tab);      
      }
      document.getElementById('btn-'+tab.name).click();
    },
    formatthedate(thedate){
      var daydate = thedate.getDate();
      if (daydate.toString().length == 1) {
         daydate = '0'+daydate;
      }
      var daymonth = thedate.getMonth() + 1;
      if (daymonth.toString().length == 1) {
         daymonth = '0'+daymonth;
      }
     // debugger;
      var yr = thedate.getFullYear();

    //  var mydate = yr+"-"+daymonth+"-"+daydate;

    var mydate = daydate+"/"+daymonth+"/"+yr;

      return mydate;
    },
    getprevmonth(thedate){
      if(thedate.getMonth) {
          thedate.setMonth(thedate.getMonth() - 1);
        } else {
          thedate.setYear(thedate.getYear() - 1);
          thedate.setMonth(12);
        }
          thedate.setDate(1);
          return thedate;
    },
    getpluser(usid='',usname=''){
        let tabclient = {
        id: "BR-"+usname,
        name: "BR-"+usname,
        usid : usid,
        usname : usname,
        type : "3"
      }

      let isExists = _.find(this.getTabs, {name: tabclient.name})
      if(!isExists) {
       // this.$store.dispatch(TYPES.CREATE_TAB, tabclient); 
        this.$store.dispatch(TYPES.CREATE_TAB, tabclient).then(res => {
          $('#myTab a[href="#'+tabclient.name+'"]').tab('show');
          document.getElementById('btn-'+tabclient.name).click();
          document.getElementById('btn-search-'+tabclient.name).click();
        });   
      } else {
         document.getElementById('btn-'+tabclient.name).click();
      }
      //$('#myTab a[href="#'+tabclient.name+'"]').tab('show');
   
     
    },
    getlastdate(y,m){
       return  new Date(y, m +1, 0).getDate();
    },
    setdate(inqtime=''){
       let now = new Date();
       if (inqtime == 1){          
          var defaultDate = now - 1000 * 60 * 60 * 24 * 1;

          defaultDate = new Date(defaultDate);
         // var yesdate = defaultDate.getFullYear() + "-" + (defaultDate.getMonth() + 1) + "-" + defaultDate.getDate();
          var yesdate = this.formatthedate(defaultDate);
          //debugger
          $('#startprof').val(yesdate);
          $('#endprof').val(yesdate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 2) {
          var datenow = this.formatthedate(now);
           $('#startprof').val(datenow);
          $('#endprof').val(datenow);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 3){
          var Date1 = now - (14 * 1000 * 60 * 60 * 24 * 1);

          var Date2 = now - (7 * 1000 * 60 * 60 * 24 * 1);

          var startdate = this.formatthedate(new Date(Date1));

          var enddate = this.formatthedate(new Date(Date2));


          //debugger
          $('#startprof').val(startdate);
          $('#endprof').val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 4){
          var Date1 = now - (7 * 1000 * 60 * 60 * 24 * 1);

          var Date2 = now - (1 * 1000 * 60 * 60 * 24 * 1);

          var startdate = this.formatthedate(new Date(Date1));

          var enddate = this.formatthedate(new Date(Date2));


          //debugger
          $('#startprof').val(startdate);
          $('#endprof').val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 5){
         let now = new Date();

           var tes = this.getprevmonth(now);

           //var tes2 = this.getprevmonth(now);

           var year = tes.getFullYear();
           var mth = tes.getMonth()+1;
           var mth2 = tes.getMonth();
           var lday = this.getlastdate(year,mth2);

           var date2 = year+"-"+mth+"-"+lday;

           var mydate = new Date(date2);

           var startdate = this.formatthedate(tes);

          var enddate = this.formatthedate(mydate);

          $('#startprof').val(startdate);
          $('#endprof').val(enddate);
          this.getreport(this.activeuser,this.activetype);
       } else if (inqtime == 6){
          let now = new Date();

          var tes = new Date(now.setDate(1));
           var year = tes.getFullYear();
          var mth = tes.getMonth()+1;
          var mth2 = tes.getMonth();
          var lday = this.getlastdate(year,mth2);

          var date2 = year+"-"+mth+"-"+lday;
          var mydate = new Date(date2);

           var startdate = this.formatthedate(tes);

          var enddate = this.formatthedate(mydate);
          $('#startprof').val(startdate);
          $('#endprof').val(enddate);
          this.getreport(this.activeuser,this.activetype);
       }
    }
  },
  mounted(){
    //this.getreport();
    this.dataTableAnak = $(this.$refs.childsTableprof).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);
  },
  watch: {
  mydatas(val) {
    this.dataTableAnak.destroy();
    this.$nextTick(() => {
      this.dataTableAnak = $(this.$refs.childsTableprof).DataTable()
    });
  }
},
}
</script>